import React, { useMemo, useCallback } from 'react';
import styled, { css } from '../../styled';
import SortableHead from './SortableHead';
import Text from '../text';
const TableHeadWrapper = styled.thead `
  ${({ theme }) => css `
    tr {
      border-bottom: 1px solid ${theme.colors.INK_300};
    }
  `}
`;
const StyledTh = styled.th `
  ${({ theme, minWidth, isSortable, offsetLeft, offsetRight, headColumnAlign, }) => css `
    box-sizing: border-box;
    width: ${`${minWidth}rem`};
    min-width: ${`${minWidth}rem`};
    left: ${`${offsetLeft}rem`};
    right: ${`${offsetRight}rem`};
    padding: ${isSortable ? '' : '1rem 0.5rem'};
    font-size: 0.875rem;
    font-weight: normal;
    text-align: ${headColumnAlign};
    transition: 0.2s;
    cursor: ${isSortable ? 'pointer' : 'auto'};
    div {
      justify-content: space-between;
      span {
        flex: 1;
        text-align: ${headColumnAlign};
      }
    }
    ${isSortable &&
    `
      &:hover {
        background-color: ${theme.colors.PRIMARY_100};
      }
    `}
  `}
`;
const TableHead = ({ columns, columnConfig, hoverable, indexWidth, indexTitle, renderIndex, fixedClasses, fixedHead, headColumnAlign, onClickSortColumn, lang = 'en', }) => {
    const indexClasses = useMemo(() => {
        const classes = [];
        if (Object.keys(columnConfig.fixedColumns).length) {
            classes.push(fixedClasses.column);
        }
        if (fixedHead) {
            classes.push(fixedClasses.head);
        }
        return classes.join(' ');
    }, [columnConfig, fixedClasses, fixedHead]);
    const getFixedClasses = useCallback((column) => {
        const classes = [];
        if (fixedHead) {
            classes.push(fixedClasses.head);
        }
        if (column.fixed) {
            classes.push(fixedClasses.column);
        }
        if (columnConfig.fixedLeftShadowColumnKey.includes(column.key)) {
            classes.push(fixedClasses.columnLeft);
        }
        if (columnConfig.fixedRightShadowColumnKey.includes(column.key)) {
            classes.push(fixedClasses.columnRight);
        }
        return classes.join(' ');
    }, [columnConfig, fixedClasses, fixedHead]);
    return (React.createElement(TableHeadWrapper, { headColumnAlign: headColumnAlign },
        React.createElement("tr", null,
            (indexTitle || renderIndex) && (React.createElement(StyledTh, { minWidth: indexWidth, offsetLeft: 0, className: indexClasses, headColumnAlign: "center", hoverable: hoverable }, indexTitle)),
            columns.map(column => (React.createElement(StyledTh, { key: column.key, isSortable: !!column.sortOption, minWidth: column.width, offsetLeft: columnConfig.fixedOffsetLeft[column.key], offsetRight: columnConfig.fixedOffsetRight[column.key], className: getFixedClasses(column), headColumnAlign: headColumnAlign, hoverable: hoverable }, column.sortOption ? (React.createElement(SortableHead, { column: column, onClickSortColumn: onClickSortColumn })) : (React.createElement(Text, { lang: lang, fontType: "Body", color: "INK_600", weight: "Semibold" }, column.title))))))));
};
export default React.memo(TableHead);
//# sourceMappingURL=TableHead.js.map